import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const cartes = [
  { icone: '🗄️', titre: 'Base de Données',   desc: 'Conception · Optimisation · Architecture',      couleur: '#1A1AE6' },
  { icone: '🌐', titre: 'Développement',      desc: 'Web · Mobile · Logiciels sur mesure',            couleur: '#6B21E8' },
  { icone: '🔒', titre: 'Cybersécurité',      desc: 'Audit · Conseil · Protection des systèmes',      couleur: '#10B981' },
  { icone: '🔌', titre: 'Réseaux',            desc: 'LAN · Câblage · Infrastructure réseau',          couleur: '#0EA5E9' },
  { icone: '⚡', titre: 'Électrique',         desc: 'Installations électriques · Énergie solaire · Maintenance',       couleur: '#F5C500' },
  { icone: '💡', titre: 'Consultation IT',    desc: 'Modernisation · Amélioration · Transformation',  couleur: '#EF4444' },
];
function AnimationCartes() {
  const navigate = (serviceId) => {
    const el = document.getElementById(serviceId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative w-80 h-80 flex items-center justify-center">

      {/* SVG lignes animées */}
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 320 320">
        <defs>
          <filter id="glow">
            <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
            <feMerge>
              <feMergeNode in="coloredBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>

        {/* Ligne Haut */}
        <line x1="160" y1="60" x2="160" y2="145"
          stroke="rgba(26,26,230,0.5)" strokeWidth="1.5"
          strokeDasharray="6,4" filter="url(#glow)">
          <animate attributeName="stroke-dashoffset" from="0" to="-20" dur="1.5s" repeatCount="indefinite"/>
        </line>

        {/* Ligne Bas-Gauche */}
        <line x1="160" y1="175" x2="60" y2="260"
          stroke="rgba(14,165,233,0.5)" strokeWidth="1.5"
          strokeDasharray="6,4" filter="url(#glow)">
          <animate attributeName="stroke-dashoffset" from="0" to="-20" dur="1.8s" repeatCount="indefinite"/>
        </line>

        {/* Ligne Bas-Droite */}
        <line x1="160" y1="175" x2="260" y2="260"
          stroke="rgba(245,197,0,0.5)" strokeWidth="1.5"
          strokeDasharray="6,4" filter="url(#glow)">
          <animate attributeName="stroke-dashoffset" from="0" to="-20" dur="2s" repeatCount="indefinite"/>
        </line>

        {/* Ligne Gauche */}
        <line x1="145" y1="160" x2="55" y2="100"
          stroke="rgba(16,185,129,0.5)" strokeWidth="1.5"
          strokeDasharray="6,4" filter="url(#glow)">
          <animate attributeName="stroke-dashoffset" from="0" to="-20" dur="2.2s" repeatCount="indefinite"/>
        </line>

        {/* Ligne Droite */}
        <line x1="175" y1="160" x2="265" y2="100"
          stroke="rgba(107,33,232,0.5)" strokeWidth="1.5"
          strokeDasharray="6,4" filter="url(#glow)">
          <animate attributeName="stroke-dashoffset" from="0" to="-20" dur="1.2s" repeatCount="indefinite"/>
        </line>
      </svg>

      {/* Carte centrale EFE Systems */}
      <div className="absolute z-10 px-6 py-4 rounded-2xl flex items-center gap-3"
        style={{
          background: 'rgba(255,255,255,0.06)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(245,197,0,0.4)',
          boxShadow: '0 0 30px rgba(245,197,0,0.15), 0 0 60px rgba(26,26,230,0.1)',
        }}>
        <span style={{ color: '#F5C500', fontSize: '22px' }}>⚡</span>
        <div>
          <p style={{ color: '#6B21E8', fontWeight: '800', fontSize: '16px' }}>EFE</p>
          <p className="text-white font-bold text-sm -mt-1">Systems</p>
        </div>
      </div>

      {/* Haut - Base de Données */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 flex flex-col items-center cursor-pointer group"
        onClick={() => navigate('services')}
      >
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-1 transition-all duration-300 group-hover:scale-110"
          style={{
            background: 'rgba(26,26,230,0.15)',
            border: '1px solid rgba(26,26,230,0.4)',
            boxShadow: '0 0 15px rgba(26,26,230,0.2)',
          }}>
          🗄️
        </div>
        <span className="text-gray-400 text-xs tracking-widest uppercase group-hover:text-white transition">Données</span>
      </div>

      {/* Gauche - Cybersécurité */}
      <div
        className="absolute left-0 top-1/3 flex flex-col items-center cursor-pointer group"
        onClick={() => navigate('services')}
      >
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-1 transition-all duration-300 group-hover:scale-110"
          style={{
            background: 'rgba(16,185,129,0.15)',
            border: '1px solid rgba(16,185,129,0.4)',
            boxShadow: '0 0 15px rgba(16,185,129,0.2)',
          }}>
          🔒
        </div>
        <span className="text-gray-400 text-xs tracking-widest uppercase group-hover:text-white transition">Sécurité</span>
      </div>

      {/* Droite - Développement */}
      <div
        className="absolute right-0 top-1/3 flex flex-col items-center cursor-pointer group"
        onClick={() => navigate('services')}
      >
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-1 transition-all duration-300 group-hover:scale-110"
          style={{
            background: 'rgba(107,33,232,0.15)',
            border: '1px solid rgba(107,33,232,0.4)',
            boxShadow: '0 0 15px rgba(107,33,232,0.2)',
          }}>
          🌐
        </div>
        <span className="text-gray-400 text-xs tracking-widest uppercase group-hover:text-white transition">Dev</span>
      </div>

      {/* Bas-Gauche - Réseaux */}
      <div
        className="absolute bottom-0 left-4 flex flex-col items-center cursor-pointer group"
        onClick={() => navigate('services')}
      >
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-1 transition-all duration-300 group-hover:scale-110"
          style={{
            background: 'rgba(14,165,233,0.15)',
            border: '1px solid rgba(14,165,233,0.4)',
            boxShadow: '0 0 15px rgba(14,165,233,0.2)',
          }}>
          {/* Icône RJ45/Réseau SVG */}
         <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="#0EA5E9" strokeWidth="1.5">
  <rect x="2" y="2" width="5" height="4" rx="1"/>
  <rect x="17" y="2" width="5" height="4" rx="1"/>
  <rect x="9.5" y="2" width="5" height="4" rx="1"/>
  <rect x="9.5" y="18" width="5" height="4" rx="1"/>
  <line x1="4.5" y1="6" x2="4.5" y2="10"/>
  <line x1="19.5" y1="6" x2="19.5" y2="10"/>
  <line x1="12" y1="6" x2="12" y2="9"/>
  <line x1="4.5" y1="10" x2="19.5" y2="10"/>
  <line x1="12" y1="10" x2="12" y2="18"/>
</svg>
        </div>
        <span className="text-gray-400 text-xs tracking-widest uppercase group-hover:text-white transition">Réseaux</span>
      </div>

      {/* Bas-Droite - Électrique */}
      <div
        className="absolute bottom-0 right-4 flex flex-col items-center cursor-pointer group"
        onClick={() => navigate('services')}
      >
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-1 transition-all duration-300 group-hover:scale-110"
          style={{
            background: 'rgba(245,197,0,0.15)',
            border: '1px solid rgba(245,197,0,0.4)',
            boxShadow: '0 0 15px rgba(245,197,0,0.2)',
          }}>
          ⚡
        </div>
        <span className="text-gray-400 text-xs tracking-widest uppercase group-hover:text-white transition">Électrique</span>
      </div>

    </div>
  );
}

function Hero() {
  const [texte, setTexte] = useState('');
  const phraseComplete = 'Solutions Numériques.';

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setTexte(phraseComplete.slice(0, i + 1));
      i++;
      if (i === phraseComplete.length) clearInterval(interval);
    }, 80);
    return () => clearInterval(interval);
  }, []);

  return (
  <section
  id="accueil"
  className="min-h-screen flex items-center justify-center px-6 pt-24"
  style={{
    background: '#050510',
    backgroundImage: `
      radial-gradient(ellipse 80% 50% at 20% 40%, rgba(26,26,230,0.15) 0%, transparent 60%),
      radial-gradient(ellipse 60% 40% at 80% 60%, rgba(107,33,232,0.12) 0%, transparent 60%),
      linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)
    `,
    backgroundSize: 'auto, auto, 40px 40px, 40px 40px',
  }}
>
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-16 w-full">

        {/* ── Texte gauche ── */}
        <div className="flex-1 text-white">

          {/* Badge identité */}
          <div className="inline-flex items-center gap-3 rounded-full px-5 py-2 mb-8 text-sm"
            style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <span>🇭🇹 Fièrement Haïtien</span>
            <span className="w-1 h-1 rounded-full bg-gray-500"></span>
            <span>🌍 Vision Mondiale</span>
          </div>

          {/* Titre */}
          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight mb-6">
  Du numérique à l'électrique,
  <br />
  <span style={{ color: '#F5C500' }}>
    on bâtit votre avenir.
  </span>
</h1>
          {/* Sous-titre */}
     <p className="text-gray-400 text-lg mb-8 max-w-lg leading-relaxed">
 EFE Systems conçoit des solutions numériques et réalise des installations électriques pour accompagner la modernisation des entreprises, des institutions et des organisations humanitaires.
</p>

          {/* Boutons CTA */}
          
          {/* Boutons CTA */}
<div className="flex flex-col gap-4 mb-12">
  <div className="flex flex-col sm:flex-row gap-4">
    
    <a  href="#services"
      className="px-8 py-4 rounded-xl font-semibold text-lg text-white text-center transition hover:opacity-90 flex items-center justify-center gap-2"
      style={{ background: '#1A1AE6' }}
    >
      Découvrir nos services
    </a>
    <Link
      to="/demande-projet"
      className="px-8 py-4 rounded-xl font-semibold text-lg text-center transition hover:opacity-90 flex items-center justify-center gap-2"
      style={{ background: '#F5C500', color: '#050510' }}
    >
      Obtenir un devis gratuit →
    </Link>
  </div>
  <p className="text-gray-500 text-sm">
    💬 Décrivez votre besoin en 2 minutes — nous vous répondons sous 24h.
  </p>
</div>
         
        </div>

        {/* ── Animation droite ── */}
        <div className="flex-1 flex justify-center items-center">
          <AnimationCartes />
        </div>

      </div>
    </section>
  );
}

export default Hero;